module.exports = __webpack_public_path__ + "static/img/5.0d36fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/clix/5.png
// module id = lA/y
// module chunks = 35